var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parametres"},[_c('v-tabs',{attrs:{"centered":""}},_vm._l((_vm.links),function(tab,i){return _c('v-tab',{key:i,attrs:{"to":{ name: tab.link}}},[_vm._v(_vm._s(tab.title))])}),1),_c('div',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }